import { useAvailableItems } from 'hooks';
import { defaultCropData } from '../config/defaultCropData';

export const useFilterDefaultCropData = ({ isTargetingApple, isVerticalMedia = false }) =>
    useAvailableItems(defaultCropData, { isTargetingApple, isVerticalMedia });
